// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.currencies.currency', {
        url: '/{currencyId}',
        views: {
            "baseView@base": {
                templateUrl: 'main/base/currencies/currency/currency.tpl.html',
                controller: 'CurrencyController as vm'
            }
        },
        resolve: {
            currency: currenciesResolver,
            createNew: function () { return false; }
        }
    });

    $stateProvider.state('base.currencies.new', {
        url: '/new',
        views: {
            "baseView@base": {
                templateUrl: 'main/base/currencies/currency/currency.tpl.html',
                controller: 'CurrencyController as vm'
            }
        },
        resolve: {
            currency: function () { return {}; },
            createNew: function () { return true; }
        }
    });
}



// @ngInject
function currenciesResolver($stateParams, CurrenciesApiService) {
    return CurrenciesApiService.getCurrency($stateParams.currencyId);
}


// @ngInject
function CurrencyController($state, currency, loadSpinnerService, CurrenciesApiService, createNew, $scope, $translate, ToasterService, confirmationDialogService) {
    var vm = this;

    vm.currency = currency;
    vm.isEditing = false;
    vm.isNew = false;
    vm.currencyCopy = {};
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactCurrencyView') !== 'false';
    vm.reactCurrencyId = createNew ? null : (currency && currency.id != null ? currency.id : null);

    // functions
    vm.save = save;
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.delete = deleteCurrency;

    // initialize
    if (createNew) {
        vm.isNew = true;
        vm.isEditing = true;
    }

    function save() {
        CurrenciesApiService.save(vm.currency).then(function (result) {
            vm.currency.id = result.data.id;
            vm.isEditing = false;
            vm.isNew = false;
            ToasterService.showSuccess('"' + vm.currency.code + '" ' + $translate.instant("common.wasSaved"), $translate.instant("base.currencies"));

        }, function (error) {
            ToasterService.showError(error.message, $translate.instant("base.currencies"));
        }).finally(function () {
            vm.isEditing = false;
            vm.isNew = false;
            $state.go('base.currencies.currency', { currencyId: vm.currency.id });
        });
    }

    function enableEditing() {
        vm.currencyCopy = angular.copy(vm.currency);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.currency = angular.copy(vm.currencyCopy);
        vm.isEditing = false;
    }

    function deleteCurrency() {

        confirmationDialogService.showDialog($translate.instant("currency.confirmDelete")).then(function (deleteConfirmed) {
            if (deleteConfirmed === true) {
                CurrenciesApiService.deleteCurrency(vm.currency.id).then(function (result) {
                    ToasterService.showSuccess('"' + vm.currency.code + '" ' + $translate.instant("common.wasDeleted"), $translate.instant("base.currencies"));
                }, function (error) {
                    ToasterService.showError($translate.instant(error.data.message), $translate.instant("base.currencies"));
                }).finally(function () {
                    vm.isEditing = false;
                    vm.isNew = false;
                    $state.go('base.currencies');
                });
            }
        });
    }
}


angular
    .module('currencies.currency', [])
    .config(stateConfig)
    .controller('CurrencyController', CurrencyController);
